import { getImage } from 'utils/format';

export const wallets = [
	{
		title: 'Blink Wallet',
		description:
			'Fácil de usar, custodiada, ideal para principiantes en Lightning.',
		image: getImage('blink.png', 'wallet'),
		link: 'https://go.bumbei.com/blink',
	},
	{
		title: 'Wallet of Satoshi',
		description:
			'Una billetera de custodia intuitiva para Bitcoin Lightning Network.',
		image: getImage('walletofsatoshi.png', 'wallet'),
		link: 'https://go.bumbei.com/wos',
	},

];
